import { alpha, createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#0F172A',
      dark: '#020617',
      light: '#334155',
    },
    secondary: {
      main: '#2563EB',
      dark: '#1D4ED8',
      light: '#60A5FA',
    },
    error: {
      main: '#DC2626',
    },
    warning: {
      main: '#D97706',
    },
    background: {
      default: '#F8FAFC',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#0F172A',
      secondary: '#64748B',
    },
    divider: '#E2E8F0',
  },
  shape: {
    borderRadius: 14,
  },
  typography: {
    fontFamily: [
      '"Segoe UI"',
      'Inter',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Helvetica Neue"',
      'sans-serif',
    ].join(','),
    h3: {
      fontWeight: 750,
      letterSpacing: '-0.035em',
    },
    h4: {
      fontWeight: 750,
      letterSpacing: '-0.03em',
    },
    h5: {
      fontWeight: 700,
      letterSpacing: '-0.02em',
    },
    h6: {
      fontWeight: 700,
      letterSpacing: '-0.01em',
    },
    button: {
      fontWeight: 700,
      textTransform: 'none',
      letterSpacing: '-0.01em',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        ':root': {
          colorScheme: 'light',
        },
        body: {
          margin: 0,
          minHeight: '100vh',
          background: '#F8FAFC',
          color: '#0F172A',
        },
        '#root': {
          minHeight: '100vh',
        },
        '*': {
          boxSizing: 'border-box',
        },
        '::-webkit-scrollbar': {
          width: 10,
          height: 10,
        },
        '::-webkit-scrollbar-thumb': {
          backgroundColor: '#CBD5E1',
          borderRadius: 999,
        },
        '::-webkit-scrollbar-track': {
          backgroundColor: '#F1F5F9',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          backdropFilter: 'blur(14px)',
          backgroundColor: 'rgba(248,250,252,0.92)',
          borderBottom: '1px solid rgba(226,232,240,0.92)',
          color: '#0F172A',
          boxShadow: 'none',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          background: '#0F172A',
          color: '#E2E8F0',
          borderRight: '1px solid rgba(255,255,255,0.06)',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          border: '1px solid #E2E8F0',
          boxShadow: '0 1px 2px rgba(15, 23, 42, 0.04)',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          border: '1px solid #E2E8F0',
          boxShadow: '0 1px 2px rgba(15, 23, 42, 0.04)',
        },
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          borderRadius: 10,
          paddingInline: 18,
          minHeight: 40,
        },
        containedPrimary: {
          background: '#0F172A',
          boxShadow: '0 1px 2px rgba(15, 23, 42, 0.12)',
          '&:hover': {
            background: '#111827',
          },
        },
        outlinedPrimary: {
          borderColor: '#CBD5E1',
          color: '#0F172A',
        },
        containedSecondary: {
          background: '#2563EB',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          backgroundColor: '#FFFFFF',
          '& fieldset': {
            borderColor: '#CBD5E1',
          },
          '&:hover fieldset': {
            borderColor: '#94A3B8',
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottomColor: '#E9EEF6',
        },
        head: {
          color: '#64748B',
          fontSize: '0.74rem',
          fontWeight: 800,
          letterSpacing: '0.08em',
          textTransform: 'uppercase',
          backgroundColor: alpha('#0F172A', 0.03),
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:last-child td, &:last-child th': {
            borderBottom: 0,
          },
          '&:hover': {
            backgroundColor: alpha('#0F172A', 0.02),
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 700,
          borderRadius: 999,
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          minHeight: 46,
          marginBottom: 2,
          borderRadius: 10,
          '&.Mui-selected': {
            backgroundColor: 'rgba(255,255,255,0.1)',
            color: '#FFFFFF',
          },
          '&.Mui-selected:hover': {
            backgroundColor: 'rgba(255,255,255,0.14)',
          },
          '&:hover': {
            backgroundColor: 'rgba(255,255,255,0.06)',
          },
        },
      },
    },
  },
});

export default theme;
